export interface ResizeOptions {
  handle: HTMLElement;
  panel: HTMLElement;
  side: 'left' | 'right';
  min: number;
  centerMin: number;
}

export function mountResize(opts: ResizeOptions): void {
  let dragging = false;
  let panelLeft = 0;
  let panelRight = 0;

  opts.handle.addEventListener('mousedown', (e) => {
    dragging = true;
    const rect = opts.panel.getBoundingClientRect();
    panelLeft = rect.left;
    panelRight = rect.right;
    opts.handle.classList.add('dragging');
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!dragging) return;
    const total = window.innerWidth;
    const raw = opts.side === 'left' ? e.clientX - panelLeft : panelRight - e.clientX;
    const maxWidth = total - opts.centerMin;
    const width = Math.max(opts.min, Math.min(raw, maxWidth));
    opts.panel.style.width = `${width}px`;
  });

  document.addEventListener('mouseup', () => {
    if (!dragging) return;
    dragging = false;
    opts.handle.classList.remove('dragging');
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  });
}
